import { ALL_BRANDS_URL_ID } from "@faire/retailer-shared/categories/urlId";
import suppliersLink, { QueryParameters as SupplierQueryParams } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId";
import brandValueSuppliersLink from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId/brand-value/brandValue";
export var getBrandValueLink = function(brandValue) {
    return brandValueSuppliersLink(ALL_BRANDS_URL_ID, brandValue);
};
export var getAllBrandsLink = function(params) {
    return suppliersLink(ALL_BRANDS_URL_ID, SupplierQueryParams.build(params));
};
